<template>
    <transition name="fade" appear>
        <div
            class="content-card"
            :class="{expanded, pulsating}"
        >
            <header :class="[!centerHeader && 'left']">
                <div class="outer-wrapper">
                    <div class="inner-wrapper">
                        <slot name="header" />
                    </div>
                </div>
            </header>
            <div class="content-wrapper">
                <p
                    ref="content"
                    class="content"
                    :style="{width: `${width}vw`}"
                >
                    <slot />
                </p>
            </div>
        </div>
    </transition>
</template>

<script>
import gsap from 'gsap';

export default {
    name: 'ContentCard',
    props: {
        pulsating: {
            type: Boolean,
            default: false
        },
        centerHeader: {
            type: Boolean,
            default: true
        },
        width: {
            type: Number,
            default: 20
        },
        expandedWidth: {
            type: Number,
            default: 0
        },
        expanded: {
            type: Boolean,
            default: true
        }
    },
    watch: {
        expanded(val)
        {
            if (val)
            {
                this.$audioController.play('reveal', {volume: 0.3});
                this.expand();
                return;
            }
            this.reduce();
        }
    },
    mounted()
    {
        if (this.expanded)
        {
            this.expand(0);
        }
    },
    destroyed()
    {
        this.stopTween();
    },
    methods: {
        expand(duration = 0.6)
        {
            const {content} = this.$refs;
            this.stopTween();
            const height = gsap.getProperty(content, 'height');
            const {width} = content.style;

            gsap.set(
                content,
                {
                    height: 'auto',
                    width: `${this.expandedWidth || this.width}vw`,
                    immediateRender: true
                }
            );

            if (!duration) { return; }

            this._tween = gsap.timeline()
                .fromTo(
                    content,
                    {height, width},
                    {
                        duration,
                        width: content.clientWidth,
                        height: content.clientHeight
                    }
                )
                .set(
                    content,
                    {
                        height: 'auto',
                        width: `${this.expandedWidth || this.width}vw`
                    }
                );
        },
        reduce(duration = 0.6)
        {
            this.stopTween();
            this._tween = gsap.to(
                this.$refs.content,
                {duration, height: 0, width: `${this.width}vw`}
            );
        },
        stopTween()
        {
            if (this._tween)
            {
                this._tween.kill();
            }
        }
    }
};
</script>

<style lang="scss" src="./ContentCard.scss" />
